<template>
  <div>
    <div class="actions row col-lg-12 mb-5 p-0 m-0 justify-content-end">
      <div v-if="parent" class="actions-right row col-lg-6 row justify-content-start p-0 m-0 gap-1 align-items-center">
        <button type="button" class="btn btn-primary" @click="parent = null">< {{ $t('goBack') }}</button>
        <span>{{parent.name}}</span>
      </div>
      <div v-else class="actions-left col-lg-6 row p-0 m-0">
       <!-- <span class="col-lg-6 m-0 p-0 text-left"> 
         <button v-bind:class="{'font-weight-bold': type == PRODUCT_TYPE}" class="status-button" @click="type = PRODUCT_TYPE">{{ $t('products') }}</button> | <button v-bind:class="{'font-weight-bold': type == BLOG_TYPE}" class="status-button" href="#" @click="type = BLOG_TYPE">{{ $t('blog') }}</button>
       </span> -->
      </div>
      <div class="actions-right row col-lg-6 row justify-content-end p-0 m-0">
        <button type="button" class="btn btn-primary" @click="addCategory">{{ $t('add') }}</button>
      </div>
    </div>
    <SearchBar @search-clicked="searchClicked"></SearchBar>
    <CTableWrapper ref="table" hover striped :caption="caption" :items="items" :actions="actions" :pages="pages" :fields="fields" clickable-rows @row-clicked="rowClicked" @action-clicked="actionClicked" @update-requested="updateItemsRequested" :sorter="{external: true}" :sorterValue="sorterValue" @sorter-value-changed="sorterValueChanged" :loading="loading">
    </CTableWrapper>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import CTableWrapper from '@/controls/PaginatedTable.vue'
import SearchBar from '@/controls/SearchBar.vue'
import router from '@/router';
import InputGetList from "@/classes/InputGetList";
import i18n from '@/helpers/i18n';
import { convertToPascalCase } from "@/helpers/utils.js";

const BLOG_TYPE = 1;
const PRODUCT_TYPE = 2;

export default {
  components: { CTableWrapper, SearchBar },
  data () {
    return {
      searchText: '',
      caption: i18n.t('categories'),
      itemsPerPage: localStorage.itemsPerPage ?? 10,
      sorterValue: { column: 'id', asc: true },
      loading: false,
      parent: null,
      type: PRODUCT_TYPE,
      //
      BLOG_TYPE: BLOG_TYPE,
      PRODUCT_TYPE: PRODUCT_TYPE
    }
  },
  computed: {
    ...mapState('categories', ['getCategoriesOutput']),
    ...mapState('categories', ['deleteCategoryByIdOutput']),
    categoryInfo: function() {
        return this.getCategoriesOutput ? this.getCategoriesOutput : null;
    },
    items: function()
    {
      return this.categoryInfo && this.categoryInfo.data ? this.categoryInfo.data : [];
    },
    pages: function()
    {
      return this.categoryInfo ? this.categoryInfo.totalPages : 1;
    },
    fields: function()
    {
      var result = [];

      if(this.type == PRODUCT_TYPE)
      {
        result.push({ key: 'brand', label: i18n.t('brand'), sortable: true });
      }
        
      result.push({ key: 'name', label: i18n.t('name'), _classes: 'font-weight-bold', sortable: true });

      return result;      
    },
    actions: function()
    {
      var result = [];
      result.push({ key: 'view', label: i18n.t('view') });

      if(!this.parent)
      {
        result.push({ key: 'viewChildren', label: i18n.t('viewChildren') });
      }

      result.push({ key: 'remove', label: i18n.t('remove') });
      
      return result;
    }
  },
  mounted: function()
  {
    this.updateItemsRequested(1, this.itemsPerPage);
  },
  methods: {
    ...mapActions('categories', ['getCategories']),
    ...mapActions('categories', ['deleteCategoryById']),
    rowClicked (item, index) {
      this.actionClicked(item, this.parent ? {key: 'view'} : {key: 'viewChildren'});
    },
    actionClicked(item, action){
      switch(action.key)
      {
        case 'view':
        {
          this.$router.push({ name: "CategoryEdit", query: { id: item.id }, params: { name: item.name, type: this.type } });
          break;
        }
        case 'viewChildren':
        {
          this.parent = item;
          break;
        }
        case 'remove':
        {
          if(confirm(this.$i18n.tc('confirmRemove', item.name, { name: item.name }))){
            this.deleteCategoryById(item.id);
          }
          break;
        }
        default:
        {
          throw "The provided action is not supported!"; 
        }
      }
    },
    updateItemsRequested(currentPage, itemsPerPage)
    {
      //Make request
      this.loading = true;
      this.itemsPerPage = itemsPerPage;

      var input = new InputGetList(itemsPerPage, currentPage, this.searchText, this.sorterValue.asc ? 1 : 2, convertToPascalCase(this.sorterValue.column));
      input.parentId = this.parent ? this.parent.id : null;
      input.level = !this.parent ? 1 : 2;
      input.type = this.type;
      
      this.getCategories(input); 
    },
    addCategory() 
    {
      router.push({ name: 'CategoryAdd', params: { type: this.type }});
    },
    searchClicked(searchText)
    {
      this.searchText = searchText;
      this.$refs.table.reset();

      this.updateItemsRequested(1, this.itemsPerPage);
    },
    sorterValueChanged(value)
    {
      this.sorterValue = value;
    }
  },
  watch:
  {
    sorterValue:
    {
      handler: function(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      },
      deep: true // Watch for changes on the properties
    },
    parent: function()
    {
      this.updateItemsRequested(1, this.itemsPerPage);
    },
    type: function()
    {
      this.updateItemsRequested(1, this.itemsPerPage);
    },
    deleteCategoryByIdOutput: function(val)
    {
      this.loading = true;

      if(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      }
      else if(val === false)
      {
        this.loading = false;
        alert(this.$t("errorDeleteCategory"));
      }
    },
    getCategoriesOutput: function(val)
    {
      if(val != null)
      {
        this.loading = false;
      }
    }
  }
}
</script>